export const dataHooks = {
  menuArrow: 'input-menu-arrow',
  status: 'input-status',
  statusIndicatorTooltip: 'status-indicator-tooltip',
  suffixes: 'input-suffixes',
  tooltip: 'input-suffix-tooltip',
  clearButton: 'input-clear-button',
};

export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const DATA_ATTR = {
  SIZE: 'data-size',
  STATUS: 'data-status',
  PREFIX: 'data-prefix',
  DISABLED: 'data-disabled',
  HOVER: 'data-hover',
  FOCUS: 'data-focus',
  LEFTBORDERRADIUS: 'data-left-border-radius',
  RIGHTBORDERRADIUS: 'data-right-border-radius',
  ROOT: 'data-input-root',
} as const;
